export default [
  {
    name: 'Clientes',
    icon: 'mdi-card-account-details-outline',
    path: '/admin/customers',
    component: () => import(/* webpackChunkName: "admin-aplifisa" */ './views/AplifisaFiscal'),
    // redirect: '/admin/aplifisa/fiscal',
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
    // children: [
    //   {
    //     name: 'Módulo Fiscal',
    //     icon: 'mdi-bank',
    //     path: '/admin/aplifisa/fiscal',
    //     component: () => import(/* webpackChunkName: "admin-aplifisa-fiscal" */ './views/AplifisaFiscal'),
    //   },
    // {
    //   name: 'Módulo Contable',
    //   icon: 'mdi-currency-eur',
    //   path: '/admin/aplifisa/contable',
    //   component: () => import(/* webpackChunkName: "admin-aplifisa-contable" */ './views/AplifisaContable'),
    // }
    // ]
  },
];
